import { ModalTransition } from '@atlaskit/modal-dialog';
import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { REJECTED_STATUS_CONTENT } from '../AppRequestDialog.constants';
export const AppRequestDialogModalRejected = props => {
  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "error"
  }, /*#__PURE__*/React.createElement("p", null, REJECTED_STATUS_CONTENT, " ", props.rejectComment)));
};